export default "__VITE_ASSET__Xs72ehYO__ 640w, __VITE_ASSET__Cyyfex3y__ 1024w";